// @flow

// Vendors
import axios from 'axios';

// Constants
import {
  API_URL,
  API_WP_REST_NONCE,
  API_WL_SITE_NONCE,
  API_WP_JSON
} from '../../config';

// Types
import {
  RequestType,
  LoginRequestType,
  ForgotPasswordRequestType,
  RegisterRequestType,
  EditUserRequestType
} from '../types';

export const request = async (options: RequestType) => {
  try {
    const response = await axios({
      baseURL: API_URL,
      timeout: 10000,
      headers: { 'X-WP-Nonce': API_WP_REST_NONCE },
      ...options,
      data: {
        wl_site_nonce: API_WL_SITE_NONCE,
        ...options.data
      }
    });
    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const loginRequest = (data: LoginRequestType) =>
  request({
    url: 'login',
    method: 'post',
    data
  });

export const forgotPasswordRequest = (data: ForgotPasswordRequestType) =>
  request({
    url: 'forgot-password',
    method: 'post',
    data
  });

export const resetPasswordRequest = (data: ForgotPasswordRequestType) =>
  request({
    url: 'reset-password',
    method: 'post',
    data
  });

export const createUserRequest = (data: RegisterRequestType) =>
  request({
    url: 'create-user',
    method: 'post',
    data
  });

export const updateUserRequest = ({ id, ...data }: EditUserRequestType) =>
  request({
    url: `update-user/${id}`,
    method: 'post',
    data
  });

export const updateUserStatusRequest = ({ id, ...data }: EditUserRequestType) =>
  request({
    url: `update-user-status/${id}`,
    method: 'post',
    data
  });

export const getUsersRequest = () =>
  request({
    url: 'get-users',
    method: 'get'
  });

export const checkOrganizationKeyRequest = (key: string) =>
  request({
    url: `check-organization-key/${key}`,
    method: 'get'
  });

export const getHiddenResourceData = (id: number) =>
  request({
    url: `get-hidden-resource/${id}`,
    method: 'get'
  });

export const getOrgFiles = (org_id: number) =>
  request({
    url: `get-org-files/${org_id}`,
    method: 'get'
  });

export const submitFeaturedVideoForm = async (formID: number, data) => {
  try {
    const response = await axios({
      method: 'POST',
      baseURL: API_WP_JSON,
      timeout: 10000,
      url: `contact-form-7/v1/contact-forms/${formID}/feedback`,
      data: data
    });

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};
